import type { TranslationTree } from '../../types';

export const camera: TranslationTree = {
  camera: {
    switchCamera: 'Kamera wechseln',
    error: {
      title: 'Kamera-Fehler',
      description: 'Wir konnten nicht auf Ihre Kamera zugreifen.',
      button: 'Erneut versuchen',
      notAllowed: 'Kamerazugriff wurde verweigert — erlauben Sie den Zugriff in den Browsereinstellungen und versuchen Sie es erneut.',
      notFound: 'Auf diesem Gerät wurde keine Kamera gefunden.',
      aborted: 'Der Kamerazugriff wurde unterbrochen — bitte versuchen Sie es erneut.',
      unknown: 'Ein unerwarteter Kamerafehler ist aufgetreten ({{name}}).',
      generic: 'Kamera ist nicht verfügbar — bitte versuchen Sie es erneut.',
    },
  },
};
